angular.module('cvsApp')

    .directive('validAmount', function() {
      return {
        restrict: 'A',
        link: function(scope, element) {
          element.bind('keydown keypress keyup', function(event) {
            //FORCE NUMBERS
            // Allow: backspace, delete, tab, escape, enter and .
            if ([46, 8, 9, 27, 13, 110, 190].indexOf(event.keyCode) !== -1 ||
                // Allow: Ctrl+A, Command+A
                (event.keyCode == 65 && (event.ctrlKey === true || event.metaKey === true)) ||
                // Allow: home, end, left, right, down, up
                (event.keyCode >= 35 && event.keyCode <= 40)) {
              // let it happen, don't do anything
              return;
            }
            // Ensure that it is a number and stop the keypress
            if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) && (event.keyCode < 96 || event.keyCode > 105)) {
              event.preventDefault();
            }
          });
        }
      };
    })

    .directive('validNumber', function() {
      return {
        restrict: 'A',
        link: function(scope, element) {
          element.bind('keydown keypress keyup', function(event) {
            //FORCE NUMBERS
            // Allow: backspace, delete, tab, escape, enter and .
            if ([46, 8, 9, 27, 13].indexOf(event.keyCode) !== -1 ||
                // Allow: Ctrl+A, Command+A
                (event.keyCode == 65 && (event.ctrlKey === true || event.metaKey === true)) ||
                // Allow: home, end, left, right, down, up
                (event.keyCode >= 35 && event.keyCode <= 40)) {
              // let it happen, don't do anything
              return;
            }
            // Ensure that it is a number and stop the keypress
            if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) && (event.keyCode < 96 || event.keyCode > 105)) {
              event.preventDefault();
            }
          });
        }
      };
    })

    .directive('validDate', function() {
      return {
        restrict: 'A',
        link: function(scope, element) {
          element.bind('keydown keypress keyup', function(event) {
            //FORCE NUMBERS
            // Allow: backspace, delete, tab, escape, enter and .
            if ([46, 8, 9, 27, 13].indexOf(event.keyCode) !== -1 ||
                // Allow: Ctrl+A, Command+A
                (event.keyCode == 65 && (event.ctrlKey === true || event.metaKey === true)) ||
                // Allow: home, end, left, right, down, up
                (event.keyCode >= 35 && event.keyCode <= 40) ||
                //  Allow: backslash
                (event.keyCode == 191 || event.keyCode == 47)) {
              // let it happen, don't do anything
              return;
            }
            // Ensure that it is a number and stop the keypress
            if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) && (event.keyCode < 96 || event.keyCode > 105)) {
              event.preventDefault();
            }
          });
        }
      };
    })

    .directive('numberConverter', function() {
      return {
        priority: 1,
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, element, attr, ngModel) {
          function toModel(value) {
            return "" + value; // convert to string
          }

          function toView(value) {
            return parseInt(value); // convert to number
          }

          ngModel.$formatters.push(toView);
          ngModel.$parsers.push(toModel);
        }
      };
    })
    .directive('disableArrows', function() {

      function disableArrows(event) {
        if (event.keyCode === 38 || event.keyCode === 40) {
          event.preventDefault();
        }
      }

      return {
        link: function(scope, element, attrs) {
          element.on('keydown', disableArrows);
        }
      };
    })
    .directive('cardexp', function(){
          return  {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, elm, attrs, ctrl){
              scope.currentYear = new Date().getFullYear();
              scope.currentMonth = new Date().getMonth() + 1;
              scope.$watch('[month,year]',function(value){
                ctrl.$setValidity('invalid',true);
                if ( scope.year == scope.currentYear
                    && scope.month < scope.currentMonth
                ) {
                  ctrl.$setValidity('invalid',false);
                }
                return value
              },true)
            }
          }
        }
    )
    .directive('numericOnly', function(){
      return {
        require: 'ngModel',
        link: function(scope, element, attrs, modelCtrl) {

          modelCtrl.$parsers.push(function (inputValue) {
            var transformedInput = inputValue ? inputValue.replace(/[^\d.-]/g,'') : null;

            if (transformedInput!=inputValue) {
              modelCtrl.$setViewValue(transformedInput);
              modelCtrl.$render();
            }

            return transformedInput;
          });
        }
      };
    })
    .directive('alphaSpace', function(){
      return {
        require: 'ngModel',
        link: function(scope, element, attrs, modelCtrl) {

          modelCtrl.$parsers.push(function (inputValue) {
            var transformedInput = inputValue ? inputValue.replace(/[^a-zA-Z ]/g,'') : null;

            if (transformedInput!=inputValue) {
              modelCtrl.$setViewValue(transformedInput);
              modelCtrl.$render();
            }

            return transformedInput;
          });
        }
      };
    })
    .directive('validNumber', function() {
      return {
        require: 'ngModel',
        link: function (scope) {
          scope.$watch('wks.number', function(newValue,oldValue) {
            var arr = String(newValue).split("");
            if (arr.length === 0) return;
            if (arr.length === 1 && (arr[0] == '-' || arr[0] === '.' )) return;
            if (arr.length === 2 && newValue === '-.') return;
            if (isNaN(newValue)) {
              scope.wks.number = oldValue;
            }
          });
        }
      };
    })
    .directive("limitToMax", [function() {
      return {
        restrict: "A",
        require: 'ngModel',
        link: function (scope, element, attrs, ngModel) {
          attrs.$set("ngTrim", "false");
          var limitLength = parseInt(attrs.limitToMax, 10);// console.log(attrs);
          scope.$watch(attrs.ngModel, function(newValue) {
            if (ngModel.$viewValue){
              if (ngModel.$viewValue.length > limitLength) {
                ngModel.$setViewValue(ngModel.$viewValue.substring(0, limitLength));
                ngModel.$render();
              }
            } else {
              angular.element(element).on("keypress", function(e) {
                /*if (this.value.length == limitLength) e.preventDefault();*/
              });
            }
          });
        }
      };
    }]);